import script from "./dashboard-chart-title.vue?vue&type=script&setup=true&lang=ts"
export * from "./dashboard-chart-title.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__